import SearchIcon from "assets/search-icon.svg";
import styles from "./NavSearchButton.module.scss";

interface Props {
  searchIsExpanded: boolean;
  openDesktopSearch: () => void;
  closeDesktopSearch: () => void;
  searchButtonRef: React.MutableRefObject<HTMLButtonElement>;
}

const NavSearchButton = ({
  searchIsExpanded,
  openDesktopSearch,
  closeDesktopSearch,
  searchButtonRef,
}: Props) => {
  return (
    <button
      className={styles.root}
      ref={searchButtonRef}
      aria-label={searchIsExpanded ? "Close Search" : "Search The Atlantic"}
      aria-expanded={searchIsExpanded}
      aria-controls="nav-desktop-search"
      onClick={searchIsExpanded ? closeDesktopSearch : openDesktopSearch}
    >
      <SearchIcon
        className={styles.searchIcon}
        data-action={searchIsExpanded ? "Close Search" : "Open Search"}
      />
    </button>
  );
};

export default NavSearchButton;
